<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="excelImportErrorForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                excelImportErrorForm: () => import('../forms/ExcelImportErrorForm'),
                headers: [
                    { text: 'Excel Import', value: 'excelImportId', table: 'excelImports', form: () => import('../forms/ExcelImportForm') },
                    { text: 'Row', value: 'row' },
                    { text: 'Description', value: 'description' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    excelImports: [],
                    items: []
                },
                sorting: [
                    { column: "description", direction: "ascending" },
                    { column: "excelImportId", direction: "ascending" },
                ],
                itemsField: 'excelImportErrors',
                editPageName: 'excelImportError',
                apiMethod: 'ExcelImportErrors',
                claimName: 'ExcelImportErrors',
                formTitle: 'Excel Import Error',
                excelTitle: 'Excel Import Errors',
                hasEditPage: false,
            }
        },
    };
</script>
